















































import Vue from 'vue';

import shareDeck from '@/components/app-buttons/btnShareDeck.vue';

export default Vue.extend({
    components: {
        'share-deck': shareDeck
    },
    props: ['title', 'dueCards', 'id', 'visibility'],
    data() {
        return {
            showModal: false,
        }
    },
    computed: {
        icon() {
            switch (this.visibility) {
                case 'public':
                    return 'fa fa-globe-americas green-text'
                case 'team':
                    return 'fa fa-users light-blue-text'
                default:
                    return 'fa fa-layer-group'
            }
        }
    }
})
